export default __webpack_public_path__ + "static/media/portfolioV2.31107b21.jpg";